/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UINotificationMessageParameter } from './uINotificationMessageParameter';
import { MessageTypeEnum } from './messageTypeEnum';


/**
 * Message data for UI formatting and localization
 */
export interface UINotificationMessage { 
    key?: string;
    template: string;
    params?: Array<UINotificationMessageParameter>;
    message_type?: MessageTypeEnum;
    severity?: string;
}
export namespace UINotificationMessage {
}


